<template>
  <div class="InstituteProject">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md12>
          <v-card class="mb-2">
            <v-card-title class="title">
              Institución vs Proyecto
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="loading || dataVals === null">
                  <download-csv
                    :data="dataVals"
                    :name="'Institución vs Proyecto.csv'"
                    :labels="labels"
                    :fields="fields"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <data-table
                :headers="headers"
                :dataVals="dataVals"
                :searchActive="true"
                :key="tableKey"
              />
            </v-card-text>

            <v-card-text>
              <table-plain
                :headers="headersConcepts"
                :dataVals="dataValsConcepts"
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import dataTable from '@/components/Tables/TableWithTotals'
import tablePlain from '@/components/Tables/TablePlain'
import JsonCSV from 'vue-json-csv'

export default {
  name: `InstituteProject`,

  components: {
    'data-table': dataTable,
    'table-plain': tablePlain,
    'download-csv': JsonCSV
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadTable()
  },

  data: function () {
    return {
      backConf: {
        path: '/semcali/rp_pry_inst/',
        page: 1
      },

      loading: false,
      progressSize: 70,
      progressWidth: 7,

      headers: [
        {
          text: 'Institución',
          align: 'left',
          value: 'institucion',
          str: 'Totales'
        },
        { text: 'P01.', value: 'P01.' },
        { text: 'P02.', value: 'P02.' },
        { text: 'P02.1.', value: 'P02.1.' },
        { text: 'P03.', value: 'P03.' },
        { text: 'P03.1.', value: 'P03.1.' },
        { text: 'P04.', value: 'P04.' },
        { text: 'P05.', value: 'P05.' },
        { text: 'P06.', value: 'P06.' },
        { text: 'P07.', value: 'P07.' },
        { text: 'P08.', value: 'P08.' },
        { text: 'P09.', value: 'P09.' },
        { text: 'P10.', value: 'P10.' }
      ],
      labels: {
        'institucion': 'Institución',
        'P01.': 'P01. Conformación de Semilleros TIC.',
        'P02.': 'P02. Fortalecimiento de las competencias básicas de los estudiantes.',
        'P02.1.': 'P02.1. Semilleros de cultura ciudadana.',
        'P03.': 'P03. Implementación de sistemas de gestión de calidad escolar.',
        'P03.1.': 'P03.1. Gestión calidad: Mediadores de comunicación.',
        'P04.': 'P04. Mejoramiento de la gestión curricular.',
        'P05.': 'P05. Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.',
        'P06.': 'P06. Recreación en actividades lúdicas para niños y niñas de la primera infancia.',
        'P07.': 'P07. Adecuación de espacios de ludoteca.',
        'P08.': 'P08. Recreación a través de la Iniciación y Formación Deportiva.',
        'P09.': 'P09. Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.',
        'P10.': 'P10. Capacitación en iniciación y sensibilización artística en comunas y corregimientos.'
      },
      fields: ['institucion', 'P01.', 'P02.', 'P02.1.', 'P03.', 'P03.1.',
        'P04.', 'P05.', 'P06.', 'P07.', 'P08.', 'P09.', 'P10.'],

      dataVals: [],
      tableKey: 0,

      headersConcepts: [
        {
          text: 'Proyecto',
          align: 'left',
          value: 'project',
          sortable: false
        },
        { text: 'Nombre', value: 'name', sortable: false }
      ],
      dataValsConcepts: [
        { project: 'P01.', name: 'Conformación de Semilleros TIC.' },
        { project: 'P02.', name: 'Fortalecimiento de las competencias básicas de los estudiantes.' },
        { project: 'P02.1.', name: 'Semilleros de cultura ciudadana.' },
        { project: 'P03.', name: 'Implementación de sistemas de gestión de calidad escolar.' },
        { project: 'P03.1.', name: 'Gestión calidad: Mediadores de comunicación' },
        { project: 'P04.', name: 'Mejoramiento de la gestión curricular.' },
        { project: 'P05.', name: 'Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.' },
        { project: 'P06.', name: 'Recreación en actividades lúdicas para niños y niñas de la primera infancia.' },
        { project: 'P07.', name: 'Adecuación de espacios de ludoteca.' },
        { project: 'P08.', name: 'Recreación a través de la Iniciación y Formación Deportiva.' },
        { project: 'P09.', name: 'Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.' },
        { project: 'P10.', name: 'Capacitación en iniciación y sensibilización artística en comunas y corregimientos.' }
      ]
    }
  },

  computed: {},

  methods: {
    /** Carga la tabla
     */
    loadTable () {
      this.loading = true
      this.dataVals = null
      let request = {
        method: 'get',
        url: this.backConf.path,
        params: {
          page: this.backConf.page
        }
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.dataVals = resp.data
          t.fillTable()
          t.loading = false
          t.tableKey += 1
        })
        .catch(err => console.error(err))
    },

    /** Rellena los campos faltantes con 0
     */
    fillTable () {
      let keys = Object.keys(this.labels)

      this.dataVals.forEach(function (element, index) {
        let containKeys = Object.keys(element)
        // Obtiene un arreglo de las llaves no encontradas
        let noFound = keys.filter(
          key => !containKeys.includes(key)
        )
        // agrega las llaves no encontradas con valor null
        noFound.forEach(function (k) {
          this.dataVals[index][k] = null
        }, this)
      }, this)
    }
  }
}
</script>
